import * as React from "react";
import * as ReactRedux from "react-redux";

import {
	getCurrentUser,
	selectUserInfo,
	selectUserFetchStatus,
	selectUserPatchStatus,
} from "../reducers/current_user";

import { selectors, actions } from "../reducers/current_user";

interface WindowWithHeap {
	heap: any;
}

declare const window: WindowWithHeap;

const mapStateToProps = state => ({
	userInfo: selectUserInfo(state),
	userFetchStatus: selectUserFetchStatus(state),
	userPatchStatus: selectUserPatchStatus(state),
	isLoggedIn: selectors.selectIsLoggedIn(state),
});

const mapDispatchToProps = {
	getCurrentUser,
	logout: actions.logout,
};

interface WithCurrentUserProps {
	userInfo: any;
	userFetchStatus: RequestStatus;
	userPatchStatus: RequestStatus;
	isLoggedIn: boolean;

	getCurrentUser();
	logout();

	children?: any;
}

/**
 * function-as-child component that provides current user info
 */
class WithCurrentUserComponent extends React.Component<WithCurrentUserProps, any> {
	componentDidMount() {
		if (this.props.userInfo === undefined) {
			this.props.getCurrentUser();
		}
	}

	componentWillReceiveProps(newProps: WithCurrentUserProps) {
		// when user info has been updated or set for the first time, identify with heap
		if (
			newProps.userInfo !== undefined &&
			(this.props.userInfo === undefined || this.props.userInfo.email !== newProps.userInfo.email)
		) {
			const user = newProps.userInfo;

			if (typeof window.heap === "undefined") {
				console.warn(
					"warning: cannot identify with heap because it is not available on the page (probably disabled in tagmanager... this page is likely running on your localhost for development)."
				);
			} else {
				try {
					window.heap.identify(user.id);
					window.heap.addUserProperties({
						"First Name": user.firstName,
						"Last Name": user.lastName,
						"Full Name": user.firstName + " " + user.lastName,
					});
				} catch (e) {
					console.error("error identifying with heap", e);
				}
			}
		}
	}

	render() {
		return this.props.children(
			this.props.userInfo,
			this.props.userFetchStatus,
			this.props.logout,
			this.props.userPatchStatus,
			this.props.isLoggedIn
		);
	}
}

export default ReactRedux.connect(
	mapStateToProps,
	mapDispatchToProps
)(WithCurrentUserComponent);



// WEBPACK FOOTER //
// ./src/components/WithCurrentUser.tsx